export default __webpack_public_path__ + "static/media/tj.dc1a2e8e.svg";